export default __webpack_public_path__ + "images/embroidery_multiply_532d1d0554dbafe5643cc202928f0e0c.jpg";